// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import Finito from "modules/finito-module";
import BaoMenu from "./../../services/bao-menu";
import baoRouter from "./../../services/bao-router";
import BaoDialog from "./../../factories/bao-dialog";
import finitoService from "./../../services/finito-service";
import Guid from "./../../factories/guid";
import dialogAttachmentsTemplate from "./dialog-attachments.html";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-tabs";
import "./../../bindings/filtering";
import "./../../bindings/bao-searcher";
function LogBookModule(parent) {
    var self = this;
    self.Parameters = JSON.parse(ko.unwrap(parent.Parameter));
    self.CustomFilter = ko.observable({});
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray([]);
    self.Models = ko.observableArray([]);
    self.Selection = ko.observableArray([]);
    self.IsLoading = ko.observable(false);
    self.Initialized = ko.observable(false);
    self.AvailableAuthorFilters = ko.observableArray([]);
    self.AvailableStateFilters = ko.observableArray([]);
    self.AvailableEventFilters = ko.observableArray([]);
    self.SelectedAuthorFilter = ko.observable();
    self.SelectedStateFilter = ko.observable();
    self.SelectedEventFilter = ko.observable();
    self.SelectedFreeTextFilter = ko.observable();
    self.ShowDeleted = ko.observable(false);
    self.AttachmentAllowedPreviewExtensions = ko.observableArray([]);
    self.ShowDeleted.subscribe(function () {
        var tmp = self.CustomFilter();
        tmp.ShowDeleted = self.ShowDeleted();
        self.CustomFilter(tmp);
    });
    self.Sorting.subscribe(function () {
        if (self.Initialized())
            self.getInformationEntries();
    });
    self.PageIndex.subscribe(function () {
        if (self.Initialized())
            self.getInformationEntries();
    });
    self.PageSize.subscribe(function () {
        if (self.Initialized()) {
            self.PageIndex(0);
            self.getInformationEntries();
        }
    });
    self.SelectedAuthorFilter.subscribe(function () {
        var tmp = self.CustomFilter();
        delete tmp.InsertBy;
        if (typeof self.AvailableAuthorFilters()[0] === "undefined" || self.SelectedAuthorFilter() !== self.AvailableAuthorFilters()[0].Username) {
            tmp.InsertBy = self.SelectedAuthorFilter();
        }
        self.CustomFilter(tmp);
    });
    self.SelectedStateFilter.subscribe(function () {
        var tmp = self.CustomFilter();
        delete tmp.InfoStateId;
        if (typeof self.SelectedStateFilter() !== "undefined" && self.SelectedStateFilter() !== "" && self.SelectedStateFilter() !== null) {
            tmp.InfoStateId = JSON.stringify([self.SelectedStateFilter()]);
        }
        self.CustomFilter(tmp);
    });
    self.SelectedEventFilter.subscribe(function () {
        var tmp = self.CustomFilter();
        delete tmp.CategoryId;
        if (typeof self.SelectedEventFilter() === "undefined" || self.SelectedEventFilter() !== "") {
            tmp.CategoryId = self.SelectedEventFilter();
        }
        self.CustomFilter(tmp);
    });
    self.SelectedFreeTextFilter.subscribe(function () {
        var tmp = self.CustomFilter();
        delete tmp.searchString;
        tmp.searchString = self.SelectedFreeTextFilter();
        self.CustomFilter(tmp);
    });
    self.CustomFilter.subscribe(function () {
        if (self.Initialized()) {
            self.PageIndex(0);
            self.getInformationEntries();
        }
    });
    self.registerMenuClick = function () {
        BaoMenu.registerEvent(function (btn) {
            if (parent.TabPage != null && parent.TabPage.IsActiveTab != null && parent.TabPage.IsActiveTab() === true) {
                switch (btn.ActionKey()) {
                    case "RefreshDashboard":
                        self.refresh();
                        break;
                }
            }
        });
    };
    self.AttachemntsDialogTitleMessage = Bao.Session.GetMessage("msgLogBookAttachmentDialogTitle");
    self.ShowAttachmentsDialog = function (info) {
        var imgUrl = "Information/DownloadAttachment/";
        var imgUrlScaledMedium = "Information/DownloadAttachmentImageMediumSized/";
        var attachments = ko.unwrap(info.InfoAttachment);
        var AttachmentDialogViewModel = function () {
            var self = this;
            self.ImgRootPath = ko.observable("");
            self.ImgPreviewRootPath = ko.observable("");
            self.Images = ko.observableArray([]);
            self.GetImagePath = function (imageId) {
                return "" + self.ImgRootPath() + ko.unwrap(imageId);
            };
            self.GetImagePathScaledMedium = function (imageId) {
                return "" + self.ImgPreviewRootPath() + ko.unwrap(imageId);
            };
            self.InfoNr = ko.observable("");
            self.DialogTitleMsg = ko.observable();
            self.ValidImagePreviewExtensions = ko.observableArray([]);
            self.DialogTitle = ko.pureComputed(function () {
                return "" + ko.unwrap(self.DialogTitleMsg) + self.InfoNr();
            });
            self.ShowImagePreview = function (filename) {
                var regex = /(\.[^\.]+)$/;
                var filenameExtension = ko.unwrap(filename).toLowerCase().match(regex);
                if (filenameExtension === null) {
                    return false;
                }
                filenameExtension = filenameExtension[1];
                var extensions = self.ValidImagePreviewExtensions();
                for (var i in extensions) {
                    if (extensions[i] === filenameExtension) {
                        return true;
                    }
                }
                return false;
            };
        };
        var attachmentDialogViewModel = new AttachmentDialogViewModel();
        attachmentDialogViewModel.Images(attachments);
        attachmentDialogViewModel.ImgRootPath(imgUrl);
        attachmentDialogViewModel.ImgPreviewRootPath(imgUrlScaledMedium);
        attachmentDialogViewModel.InfoNr(info.InfoNr());
        attachmentDialogViewModel.DialogTitleMsg = self.AttachemntsDialogTitleMessage();
        attachmentDialogViewModel.ValidImagePreviewExtensions(self.AttachmentAllowedPreviewExtensions());
        var dialog = new BaoDialog();
        dialog.Title(attachmentDialogViewModel.DialogTitle());
        dialog.Template(dialogAttachmentsTemplate);
        dialog.ViewModel(attachmentDialogViewModel);
        dialog.Open();
    };
    self.HasValidAttachments = function (info) {
        var attachments = info.InfoAttachment.peek();
        if (typeof attachments === "undefined" || attachments === null) {
            return false;
        }
        for (var i in attachments) {
            if (ko.unwrap(attachments[i].DeleteInRevision) === null) {
                return true;
            }
        }
        return false;
    };
    self.ToHashObject = function (customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };
    self.refresh = function () {
        return self.getInformationEntries();
    };
    self.link = function (index, model) {
        var linkHash = model.OpenUrl();
        baoRouter.setHash(linkHash);
    };
    self.NewDeficiency = function () {
        var linkHash = "Information/" + Guid() + "/" + self.Parameters.ReportOrgUnitId;
        baoRouter.setHash(linkHash);
    };
    self.getAvailableAuthors = function () {
        return Bao.post("Start/LogBookGetAvailableAuthors", JSON.stringify({})).done(function (data) {
            if (data) {
                self.AvailableAuthorFilters(data);
            }
        });
    };
    self.getAvailableStates = function () {
        return Bao.post("Start/LogBookGetAvailableStates", JSON.stringify({})).done(function (data) {
            if (data) {
                self.AvailableStateFilters([{
                        InfoStateText: "",
                        InfoStateId: null
                    }].concat(data));
            }
        });
    };
    self.getLogBookModuleModel = function () {
        return Bao.post("Start/GetLogBookModuleModel", JSON.stringify({})).done(function (data) {
            if (data) {
                self.AttachmentAllowedPreviewExtensions(data.AttachmentAllowedPreviewExtensions);
            }
        });
    };
    self.getAvailableCategories = function () {
        return Bao.post("Information/GetCategories", JSON.stringify({
            id: null,
            reportId: self.Parameters.ReportOrgUnitId
        })).then(function (result) {
            ko.map.fromJS(result, self.AvailableEventFilters);
        });
    };
    self.setDefaultFilters = function () {
        var def = $.Deferred();
        def.resolve();
        return def.promise();
    };
    self.getInformationEntries = function () {
        self.IsLoading(true);
        var customFilter = self.ToHashObject(ko.unwrap(self.CustomFilter));
        return Bao.post("Start/LogBookGetInfos", JSON.stringify({
            searchString: ko.unwrap(self.CustomFilter).searchString,
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting(),
            customFilter: customFilter,
            autoComplete: false
        })).then(function (result) {
            ko.map.fromJS(result, self);
            self.IsLoading(false);
        });
    };
    self.dispose = function () {
        Bao.unbindEvent("RefreshLogBook", self.refresh);
    };
    self.init = function () {
        self.IsLoading(true);
        var def = $.Deferred();
        Bao.bindEvent("RefreshLogBook", self.refresh);
        $.when(self.setDefaultFilters(), self.getAvailableAuthors(), self.getAvailableStates(), self.getAvailableCategories(), self.getLogBookModuleModel()).done(function () {
            def.resolve();
        });
        return def;
    };
    self.loaded = function () {
        var def = $.Deferred();
        self.IsLoading(false);
        self.registerMenuClick();
        $.when(self.getInformationEntries()).done(function () {
            self.Initialized(true);
            def.resolve();
        });
        return def;
    };
}
;
export default LogBookModule;